import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import "../../Styles/Pages/orderprintinvoice.scss";
import { asset_url } from "../../app-config";
import {
	_formatCurrency,
	_convertToUpperCase,
	_capitalizeText,
} from "../../Utils/helpers";
import Avatar from "../../Resources/Avatar";

function OrderPrintInvoice(props) {
	const [onlineOrders, setOnlineOrders] = useState([]);

	useEffect(() => {
		if (props.isBreak) {
			const pageSize = 10;
			const data = props.statesData.orderDetailRetail.OnlineOrder;
			const pageGroups = data
				.map((e, i) => {
					return i % pageSize === 0 ? data.slice(i, i + pageSize) : null;
				})
				.filter(e => e);
			setOnlineOrders(pageGroups);
		}
	}, [props.statesData.orderDetailRetail.OnlineOrder, props.isBreak]);

	return (
		<div
			className={`Paylater__Invoice__Box print-page-break ${
				props.isPayLaterOrder ? "Paylater__Watermark" : ""
			}`}
		>
			<div className="empty-header-print"></div>
			<div className="empty-footer-print"></div>
			<div className="Invoice">
				<div className="Invoice__Header">
					<p>INVOICE</p>
					<div className="Invoice__Logo__Field">
						{props.context.HeaderData.userProfileImg ? (
							<img
								src={asset_url + props.context.HeaderData.userProfileImg}
								alt=""
							/>
						) : (
							<Avatar name={props.context.HeaderData.BusinessName} size={35} />
						)}

						<div className="Invoice__Log__Text">
							{props.context.HeaderData.companyName && (
								<p>{props.context.HeaderData.companyName}</p>
							)}
							<p>Omnibiz Retail</p>
							{/* {props.context.HeaderData.companyName && (
								<p>{props.context.HeaderData.BusinessName}</p>
							)} */}
						</div>
					</div>
				</div>

				<div className="Invoice__Customerdetails__Field">
					<div className="Invoice__Customerdetails__Field__Header">
						<p>Customer Details</p>
					</div>

					<div className="Invoice__Details">
						<div className="Invoice__Customerdetails__Field__Items">
							<div className="Invoice__Customerdetails__Field__Items__One">
								<p>Name</p>
								<p>
									{props.propsData.orderDetails.OrganizationName ||
										props.statesData.orderDetailRetail.CustomerName ||
										"Guest"}
									{props.statesData.orderDetailRetail.Storename && (
										<>
											<br />
											{props.statesData.orderDetailRetail.Storename}
										</>
									)}
								</p>
							</div>
						</div>
						<div className="Invoice__Customerdetails__Field__Items">
							<div className="Invoice__Customerdetails__Field__Items__One">
								<p>Phone number</p>
								{props.statesData.orderDetailRetail.CustomerPhone && (
									<p>{props.statesData.orderDetailRetail.CustomerPhone}</p>
								)}
								{props.statesData.alternatePhones.alternatePhone1 && (
									<p>{props.statesData.alternatePhones.alternatePhone1}</p>
								)}
								{props.statesData.alternatePhones.alternatePhone2 && (
									<p>{props.statesData.alternatePhones.alternatePhone2}</p>
								)}
							</div>
						</div>
						<div className="Invoice__Customerdetails__Field__Items">
							<div className="Invoice__Customerdetails__Field__Items__One">
								<p>Delivery address</p>
								<p>
									{props.statesData.orderDetailRetail.OrderLocation &&
										(props.statesData.shopNo
											? `#${props.statesData.shopNo}, ${props.statesData.orderDetailRetail.OrderLocation}`
											: `${props.statesData.orderDetailRetail.OrderLocation}`)}
								</p>
							</div>
						</div>
					</div>
					{props.statesData.orderDetailRetail &&
						props.statesData.orderDetailRetail.isQrCodeEnabled === 1 && (
							<div className="Invoice__Customerdetails__Field__Itemstwo">
								<div className="Invoice__Customerdetails__Field__Items__Two">
									<div className="Invoice__Customerdetails__Field__Items__Subtwo">
										<p>QR Code</p>
										<p></p>
										<p>Enabled</p>
									</div>
									<p>
										(You may scan Retailer’s QR Code to mark order as delivered)
									</p>
								</div>
							</div>
						)}
				</div>
				<div className="Order__Details">
					<div className="Order__Details__Box__Left">
						<div className="Order__Details__Boxtitle">
							<p>Order details</p>
							{props.statesData.orderDetailRetail &&
								props.statesData.orderDetailRetail.isFirstOrder === 1 && (
									<p>First Order</p>
								)}
						</div>
						<div className="Order__Details__Textbox">
							<div className="Order__Details__Textone">
								<p>Order date</p>
								<p>
									{dayjs(props.statesData.orderDetailRetail.Createddate).format(
										`MMM D, YYYY.${window.screen.width > 350 ? "h:mm a" : ""}`,
									)}
								</p>
							</div>
							<div className="Order__Details__Texttwo">
								<p>Order number</p>
								<p>
									{!props.propsData.isSupplyRequestOrder &&
									props.context.isOmsAdminBusiness
										? props.propsData.orderDetails.Orderid
										: `${props.propsData.orderDetails.MasterOrderId}-${props.propsData.orderDetails.Orderid}`}
								</p>
							</div>
						</div>
					</div>

					<div className="Order__Details__Box__Right">
						<p>{props.isPayLaterOrder ? "PayLater" : "Amount Payable"}</p>
						<p>{_formatCurrency(props.netPayable)}</p>
					</div>
				</div>

				{!props.isBreak && (
					<table
						className={`Invoice__Table__Item ${props.isBreak ? " break" : ""}`}
					>
						<thead className="Table__Header">
							<tr className="Table__Row">
								<th>No</th>
								<th>Description</th>
								<th>SKU Code</th>
								<th>Unit Cost</th>
								<th>Quantity</th>
								<th>Subtotal</th>
							</tr>
						</thead>

						<tbody className="Table__Body">
							{props.statesData.orderDetailRetail.OnlineOrder &&
								props.statesData.orderDetailRetail.OnlineOrder.map(
									(item, i) => {
										return (
											<tr
												className={`Table__Rowtwo ${
													i === 11 ? " page-break" : ""
												}`}
												key={`tr_item-${i}`}
											>
												<td>{i + 1}</td>
												<td>{_capitalizeText(item.ItemName || "")}</td>
												<td>{item.skucode || ""}</td>
												<td>{_formatCurrency(item.Price)}</td>
												<td>{item.Quantity}</td>
												<td>{_formatCurrency(item.Price * item.Quantity)}</td>
											</tr>
										);
									},
								)}
						</tbody>
					</table>
				)}

				{props.isBreak &&
					onlineOrders &&
					onlineOrders.map((orders, page) => (
						<table
							className={`Invoice__Table__Item ${
								props.isBreak && page < onlineOrders.length - 1 ? " break" : ""
							}`}
						>
							<thead className="Table__Header">
								<tr className="Table__Row">
									<th>No</th>
									<th>Description</th>
									<th>SKU Code</th>
									<th>Unit Cost</th>
									<th>Quantity</th>
									<th>Subtotal</th>
								</tr>
							</thead>

							<tbody className="Table__Body">
								{orders.map((item, i) => {
									return (
										<tr
											className={"Table__Rowtwo"}
											key={`tr_item-${page * 10 + i}`}
										>
											<td>{page * 10 + i + 1}</td>
											<td>{_capitalizeText(item.ItemName || "")}</td>
											<td>{item.skucode || ""}</td>
											<td>{_formatCurrency(item.Price)}</td>
											<td>{item.Quantity}</td>
											<td>{_formatCurrency(item.Price * item.Quantity)}</td>
										</tr>
									);
								})}
							</tbody>
						</table>
					))}

				<div className="Invoice__Subtotal__Box">
					{props.statesData.orderDetailRetail.OnlineOrder ? (
						<div className="Invoice__Subtotal__Box__One">
							<p>Quantity</p>
							<p>
								{props.statesData.orderDetailRetail.OnlineOrder.length} items,{" "}
								{props.statesData.orderDetailRetail.OnlineOrder.reduce(
									(acc, curr) => acc + curr.Quantity,
									0,
								)}{" "}
								units
							</p>
						</div>
					) : null}
					{Number(props.statesData.orderDetailRetail.TotalOrderValue) > 0 &&
						props.netPayable !==
							props.statesData.orderDetailRetail.TotalOrderValue && (
							<div className="Invoice__Subtotal__Box__Two">
								<p>Total Price</p>
								<p>
									{_formatCurrency(
										props.statesData.orderDetailRetail.TotalOrderValue,
									)}
								</p>
							</div>
						)}
					{Number(props.statesData.orderDetailRetail.couponDiscount) > 0 && (
						<div className="Invoice__Subtotal__Box__Two">
							<p>
								<span className="couponName">
									{_convertToUpperCase(
										props.statesData.orderDetailRetail.CouponCode,
									)}
								</span>
							</p>
							<p>
								{_formatCurrency(
									props.statesData.orderDetailRetail.couponDiscount,
								)}
							</p>
						</div>
					)}
					{Number(props.statesData.orderDetailRetail.promoDiscount) > 0 && (
						<div className="Invoice__Subtotal__Box__Two">
							<p>Promo Discount</p>
							<p>
								{_formatCurrency(
									props.statesData.orderDetailRetail.promoDiscount,
								)}
							</p>
						</div>
					)}
					{Number(props.statesData.orderDetailRetail.PaidFromWallet) > 0 && (
						<div className="Invoice__Subtotal__Box__Two">
							<p>Paid From Wallet</p>
							<p>
								{_formatCurrency(
									props.statesData.orderDetailRetail.PaidFromWallet,
								)}
							</p>
						</div>
					)}
					{Number(props.statesData.orderDetailRetail.omniPointsDiscount) >
						0 && (
						<div className="Invoice__Subtotal__Box__Two">
							<p>Omoni Discount</p>
							<p>
								{_formatCurrency(
									props.statesData.orderDetailRetail.omniPointsDiscount,
								)}
							</p>
						</div>
					)}
					<div className="Invoice__Subtotal__Box__Two">
						<p>Net Payable</p>
						<p>{_formatCurrency(props.netPayable)}</p>
					</div>
					<div className="Line__Through"></div>
					{Number(props.statesData.orderDetailRetail.ConvenienceFee) > 0 && (
						<div className="Invoice__Subtotal__Box__Three">
							<p>Service Charge</p>
							<p>
								{_formatCurrency(
									props.statesData.orderDetailRetail.ConvenienceFee,
								)}
							</p>
						</div>
					)}
					{props.isPayLaterOrder && (
						<div className="Invoice__Subtotal__Box__Four">
							<p>Amount to pay Later</p>
							<p>{_formatCurrency(props.totalPayableAmount)}</p>
						</div>
					)}
					{props.isPayLaterOrder && (
						<div className="Notice">
							<p>*DO NOT COLLECT PAYMENT</p>
						</div>
					)}
				</div>
				{props.statesData.orderDetailRetail.Iscancelled &&
				props.statesData.orderDetailRetail.OrderCancelDate ? (
					<div
						className="invoice-details-body-project"
						style={{
							paddingTop: "18px",
							borderBottom: "none",
						}}
					>
						<div className="light" style={{ paddingBottom: "8px" }}>
							Order Cancelled on
						</div>{" "}
						{dayjs(props.statesData.orderDetailRetail.OrderCancelDate).format(
							"MMM D, YYYY. h:mm a",
						)}
						<div style={{ padding: "15px 0px 0px" }}>
							<div className="light" style={{ paddingBottom: "8px" }}>
								Why order was cancelled
							</div>
							{props.statesData.orderDetailRetail.OrderCancelReason || (
								<i style={{ opacity: 0.6 }}>no reason given</i>
							)}
						</div>
					</div>
				) : null}
				{props.statesData.orderDetailRetail.RTOReason && (
					<div style={{ padding: "15px 0px 0px" }}>
						<div className="light" style={{ paddingBottom: "8px" }}>
							RTO Reason
						</div>
						{props.statesData.orderDetailRetail.RTOReason}
					</div>
				)}
				{props.statesData.orderDetailRetail.RescheduleDate && (
					<div
						style={{
							padding: props.statesData.orderDetailRetail.RTOReason
								? "15px 0px 0px"
								: "0px",
						}}
					>
						<div className="light" style={{ paddingBottom: "8px" }}>
							Reschedule Date
						</div>
						{dayjs(props.statesData.orderDetailRetail.RescheduleDate).format(
							"MMM D, YYYY",
						)}
					</div>
				)}
				{props.statesData.orderDetailRetail.accountNo && (
					<>
						<div className="light" style={{ fontWeight: "600" }}>
							Omnipay Account Details
						</div>
						<div className="account_details_label">
							<div className="light">
								Acc Number -{" "}
								<span>{props.statesData.orderDetailRetail.accountNo}</span>
							</div>
						</div>
						<div className="account_details_label">
							<div className="light">
								Bank Name -{" "}
								<span>{props.statesData.orderDetailRetail.bankName}</span>
							</div>
						</div>
						<div className="account_details_label">
							<div className="light">
								Acc Name -{" "}
								<span>{props.statesData.orderDetailRetail.accountName}</span>
							</div>
						</div>
					</>
				)}
				{props.isPayLaterOrder ? (
					<div className="Invoice__Tc">
						<p>Terms & Conditions</p>
						<p>Paylater amount to be paid 15 days of order delivery.</p>
						<p>
							Please pay into{" "}
							<span>Account Noumber; 8203554020, Bank Name; FCMB.</span>
						</p>
					</div>
				) : (
					""
				)}
			</div>
			<div className="Footer">
				<div className="Footer__Text__Box">
					<div className="Footer__Text__Left">
						<p>
							Do you have any issue please call Customer Service 0700 0055 555
						</p>
					</div>
				</div>
			</div>
		</div>
	);
}

export default OrderPrintInvoice;
